import React from "react";
// import Avatar from "../Avatar";
import { useTranslation } from "react-i18next";
import classesUserInfo from "./UserInfo.module.scss";
import { Box, Chip, useTheme, Tooltip } from "@mui/material";
import AvatarDefault from "../../assets/images/avatar/avatar-empty.svg";
import { BUCKET_SHOP_IMAGES } from "constants/api";

const UserInfo = ({
  name = "",
  img = null,
  myUser = null,
  parent = null,
  patient = null,
  email = null,
  className = "",
  style = null,
  onClick = null,
  teste = null,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const finalClass = !onClick
    ? classesUserInfo.UserInfo
    : classesUserInfo.UserInfo + " " + classesUserInfo.IsLink;

  return (
    <div style={style} className={finalClass + " center " + className}>
      <>
        <div
          style={
            myUser?.parent_activity_status == "false"
              ? { filter: "grayscale(1)" }
              : undefined
          }
        >
          {/* Renderiza a imagem que vem do avatar */}
          <div
            style={{
              width: "50px",
              marginRight: "10px",
              marginTop: "10px",
              marginLeft: "-20px",
            }}
          >
            <img src={img ? BUCKET_SHOP_IMAGES(img) : AvatarDefault} />
          </div>
        </div>
        <div className={classesUserInfo.UserInfoInfos}>
          {parent && (
            <label className={classesUserInfo.TopLabel}>
              {t("global.my_user")}
            </label>
          )}
          {patient && (
            <label
              className={classesUserInfo.TopLabelPatient}
              style={{
                color:
                  myUser?.parent_activity_status == "false"
                    ? theme.palette.tertiary.dark
                    : undefined,
              }}
            >
              {t("global.user")}
            </label>
          )}
          <p
            className={classesUserInfo.InfoTitle}
            style={{
              color:
                myUser?.parent_activity_status == "false"
                  ? theme.palette.tertiary.dark
                  : undefined,
            }}
            tabIndex={onClick ? "0" : null}
            onClick={onClick ? () => onClick() : () => {}}
          >
            {/* Aqui aparece o nome dos usuários no componente de troca de usuário */}
            {name}
          </p>
          {email && (
            <Tooltip title={email}>
              <p className={classesUserInfo.Email}>{email}</p>
            </Tooltip>
          )}
        </div>

        {myUser && myUser?.parent_activity_status == "false" && (
          <Box>
            <Chip
              label="INATIVO"
              color="error"
              onClick={onClick ? () => onClick() : () => {}}
            />
          </Box>
        )}
      </>
    </div>
  );
};
export default UserInfo;
